export default __webpack_public_path__ + "static/media/doc1.34e2fcbb.jpeg";